import { render, staticRenderFns } from "./Info.vue?vue&type=template&id=31c88916"
import script from "./Info.vue?vue&type=script&lang=js"
export * from "./Info.vue?vue&type=script&lang=js"
import style0 from "./Info.vue?vue&type=style&index=0&id=31c88916&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31c88916')) {
      api.createRecord('31c88916', component.options)
    } else {
      api.reload('31c88916', component.options)
    }
    module.hot.accept("./Info.vue?vue&type=template&id=31c88916", function () {
      api.rerender('31c88916', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/pop-up/common/Info.vue"
export default component.exports